import { NotifyHelper } from "../../../helpers/toast";
import { eQuocTichActionObj } from "../../action-types/category/IQuocTichActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const quocTichActions = {
    ...generateActions(eQuocTichActionObj,"QUOC_TICH"),
    ...generateActionForKey(eQuocTichActionObj, "QUOC_TICH","LOAD_ERROR", (m) => {NotifyHelper.Error(m)}),
}